import { Component } from '@angular/core';
import { BlockBarChart } from '@src/app/@shared/models/step.model';
import { BlockAbstractComponent } from '@app/components/blocks/block.abstract.component';

@Component({
  selector: 'pl-block-bar-chart',
  templateUrl: './block-barChart.component.html',
})
export class BlockBarChartComponent extends BlockAbstractComponent<BlockBarChart, null> {
  protected override initForm(): void {}

  protected override patchFormWithEmptyValue(): void {}

  protected override patchFormFromBlock(): void {}
}
